import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('api', 'endereco');

const enderecoActions = {
  obter: { method: 'GET', url: `${basePath}/{id}` },
};

export default (resource) => resource(`${basePath}`, {}, enderecoActions);
